import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<MiDataTableAction>({})
export default class MiDataTableAction extends Vue {
  @Prop()
  protected options!: MiDataTableActionOptions;

  @Prop()
  protected to!: string;

  protected handleClick() {
    if (! this.to) { this.$emit('click'); }
  }
}

export interface MiDataTableActionOptions {
  icon: string;
  hoverColor?: string;
  tooltipText?: string;
}
